import { render, staticRenderFns } from "./OnePhaseOneFileJg.vue?vue&type=template&id=7e6d23ec"
import script from "./OnePhaseOneFileJg.vue?vue&type=script&lang=js"
export * from "./OnePhaseOneFileJg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports